// --- Transcription ---
// My price: 0.45€/h - 0.0075€/min - 0.000125€/sec
//

// Resource units describe what was consumed in domain terms,
// independent of how it's priced. The billing layer converts
// resource amounts to microcredit via a pricing table.
export type TResourceUnit =
  "transcribed_second" | "translated_character" | "dictionary_lookup";

const transcribed_second = 150; // 0.000150 credits/s or 0.009 credits / minute or 0.54 credits / hour
const transcribed_minute = transcribed_second * 60;
const transcribed_hour = transcribed_minute * 60;
const translated_character = 120;
const translated_thousand_characters = translated_character * 1000;
const translated_million_characters = translated_character * 1_000_000;
const dictionary_lookup = 10_000; // 0.01 credit per lookup

// How many microcredit per one resource unit.
export const pricePerResourceUnit: Record<TResourceUnit, number> = {
  transcribed_second,
  translated_character,
  dictionary_lookup,
};

export const pricing = {
  transcribed_second: {
    microcredit: transcribed_second,
    credits: transcribed_second / 1000000,
  },
  transcribed_minute: {
    microcredit: transcribed_minute,
    credits: transcribed_minute / 1000000,
  },
  transcribed_hour: {
    microcredit: transcribed_hour,
    credits: transcribed_hour / 1000000,
  },
  translated_character: {
    microcredit: translated_character,
    credits: translated_character / 1000000,
  },
  translated_thousand_characters: {
    microcredit: translated_thousand_characters,
    credits: translated_thousand_characters / 1000000,
  },
  translated_million_characters: {
    microcredit: translated_million_characters,
    credits: translated_million_characters / 1000000,
  },
  dictionary_lookup: {
    microcredit: dictionary_lookup,
    credits: dictionary_lookup / 1000000,
  },
};

/*

Calculation:

===== TRANSCRIPTION =====

0.0043 * (0.87 * 1.1) * 2 / 60 = 0.00013717
- $0.0043 price per minute for Nova-3 Monolingual prerecorded
- 0.87 = 1 USD in EUR
- * 1.1 = account for exchange rate fluctuation
- * 2 = 100% markup to account for payment fees & risk
- / 60 = convert minutes to seconds

0.000138 credits / second
0.00828 credits / minute
0.4968 credits / hour

Make all numbers round:
0.000150 credits / second
0.009 credits / minute
0.54 credits / hour

===== TRANSLATION =====

DeepL has a free tier which includes 500k chars per month.
If I cross this limit, I have to pay €29.75 / month.
€29.75 / 500 000 * 1 000 000 => 59.5 € / million characters
=> 0.000060 € / char

Add 100 % markup:

0.000120 credits / char

<notes>
  GoogleTranslate: $20 => 17.76 €, taking into account possible currency rate fluctuation: +10% => 19.53 €, let's use 20 €.
  20 € / million char
  => 0.000020 € / char
</notes>


===== MARGIN =====

See: ../pricing/index.html for calculation.
A 100% margin covers Paddle fees, currency and chargeback risk, even at a €5 topup.
We could give extra credits when topping up a higher amount.


*/
